import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-minus-sm-icon',
  templateUrl: 'minus-sm-icon.component.html'
})
export class MinusSmIconComponent {
  constructor() {}
}
